export const AUTHOR_LABEL_WIDTH = 58;
export const AUTHOR_DIVIDER_WIDTH = 9;
export const AUTHOR_OVERFLOW_CHIP_WIDTH = 40;
export const AUTHOR_CHIP_GAP = 4;
export const AUTHOR_CHIP_MAX_WIDTH = 160;
export const AUTHOR_CHIP_CHROME_WIDTH = 44;
export const AUTHOR_CHIP_CHAR_WIDTH = 7;

export function estimateAuthorChipWidth(label) {
    const text = String(label || 'Unknown');
    return Math.min(
        AUTHOR_CHIP_MAX_WIDTH,
        AUTHOR_CHIP_CHROME_WIDTH + Math.ceil(text.length * AUTHOR_CHIP_CHAR_WIDTH),
    );
}

/**
 * How many named author chips fit in the toolbar slot.
 * Always reserves room for +N when at least one author is hidden.
 *
 * @returns {number} inline chip count (0..labels.length)
 */
export function countFittingAuthorChips({
    availableWidth,
    labels = [],
    labelWidth = AUTHOR_LABEL_WIDTH,
    dividerWidth = AUTHOR_DIVIDER_WIDTH,
    overflowChipWidth = AUTHOR_OVERFLOW_CHIP_WIDTH,
    gap = AUTHOR_CHIP_GAP,
} = {}) {
    const n = labels.length;
    if (n === 0) return 0;

    const remaining = availableWidth - labelWidth - dividerWidth;
    if (remaining <= 0) return 0;

    const chipWidths = labels.map(estimateAuthorChipWidth);

    for (let inline = n; inline >= 0; inline -= 1) {
        const overflow = n - inline;
        let width = 0;
        for (let i = 0; i < inline; i += 1) {
            if (i > 0) width += gap;
            width += chipWidths[i];
        }
        if (overflow > 0) {
            if (inline > 0) width += gap;
            width += overflowChipWidth;
        }
        if (width <= remaining) return inline;
    }
    return 0;
}
